import React from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { Chip, Select } from "@mui/material";
import "./Inputs.scss";
// import { api } from "@/shared/api/gen/api";
import {useFetch} from "@/shared/hooks/useFetch";
import SelectInput, { AutoCompleteArrayInput, AutoCompleteInput, IChoice, SelectArrayInput } from "./SelectInput";
import { TextField } from "../Fields/Fields";
import StringInput, { TextInput } from "./StringInput";
import api from "@/shared/api/api";
import { ProjectListResponseDTO } from "@/shared/api/gen/data-contracts";


function Bubble({ label, handleDelete }: any) {
    return (
        <Chip label={label} variant="outlined" onDelete={handleDelete} />
    )
}
function AddHumanInput({ label, onClick }: any) {
    return (
        <Chip className="cursor-pointer" label={label} variant="outlined" onClick={onClick} />
    )
}
function CustomAutocompleteInput({label, placehholder, onChange, register, options}:any) {
    return (
        <div className="SearchPopUp">
            <StringInput 
                placeholder={placehholder}
                label={label}
                register={register} 
            />
            {options.map((el: ProjectListResponseDTO)=> 
                <TextField 
                    className="cursor-pointer"
                    key={`${el.id}`}
                    value={el.title}
                    onClick={()=>onChange(el)}
                />
            )}
        </div>
    )
}
/**
 * ReferenceInput 
 * referenceRequest - запрос на получение связанной записи
 * @param param0 
 * @returns 
 */
export const ReferenceInput = ({referenceRequest, register, label}: any) => {
    const {data} = useFetch(()=>referenceRequest(), [], [])
    return (
        <SelectInput
            label={label}
            choices={data.map((el: any)=>({value: el?.id, title: el?.title})) as IChoice[]}
            register={register}
        />
    )
}
/**
 * ReferenceInput 
 * referenceRequest - запрос на получение связанной записи
 * @param param0 
 * @returns 
 */
export const ReferenceArrayInput = ({referenceRequest, register, label, ...props}: any) => {
    const {data} = useFetch(()=>referenceRequest(), [], [])
    console.log('data', data)
    if (!data) return null
    return (
        <SelectArrayInput
            label={label}
            choices={data.map((el: any)=>({value: el?.id, title: el?.title})) as IChoice[]}
            register={register}
            {...props}
        />
    )
}


export function ProjectSearch({chooseProject}: any) {
    const {register} = useForm();
    const [textS, setTextS] = React.useState<string>("");
    const {data} = useFetch<ProjectListResponseDTO[]>(async () => api.projects.getProjectsApiProjectsGet(), [], [textS])
    if (!data && data.length <= 0) return null
    return (
        <CustomAutocompleteInput
            label=" "
            placehholder="Проект"
            register={register("text-search", {onChange: (data) => setTextS(data.target.value)})}
            options={data}
            onChange={(el: ProjectListResponseDTO)=>chooseProject({title: el.title, id: el.id})}
        />
    )
}
// function EmployeeSearch({choosePassanger}: any) {
//     const {register} = useForm();
//     const [textS, setTextS] = React.useState<string>("");
//     const {data} = useFetch<any[]>(async () => api.getEmployeesApiEmployeesGet({text_search: textS}), [], [textS])
//     if (!data && data.length <= 0) return null
//     return (
//         <CustomAutocompleteInput
//             label=" "
//             placehholder="Поиск исполнителя"
//             register={register("text-search", {onChange: (data) => setTextS(data.target.value)})}
//             options={data}
//             onChange={(el:any)=>choosePassanger({title: el.fio, id: el.id})}
//         />
//     )
// }

// function HumanInput({ getOne, register, control, defaultValue, passanger, ...props }: any) {
//     const { replace } = useFieldArray({ control, name: register.name })
//     const [humans, setHumans] = React.useState<Array<any>>([]);
//     const [openAdd, setOpenADD] = React.useState<boolean>(false);
//     const initDefaultValues = () => {
//         if (defaultValue) {
//             if (passanger) {
//                 defaultValue.map((el: number)=> {
//                     api.getPassengersDetailApiPassengersIdGet(el).then((res)=>{
//                         addHuman({id: res.data.id, title: res.data.fio})
//                     })
//                 })
//             } else {
//                 defaultValue.map((el: number)=> {
//                     api.getEmployeesDetailApiEmployeesIdGet(el).then((res)=>{
//                         addHuman({id: res.data.id, title: res.data.fio})
//                     })
//                 })
//             }
//         }
//     }
//     React.useEffect(()=>{
//         console.log("default values", passanger, defaultValue)
//         initDefaultValues()
//     }, [defaultValue])
//     const addHuman = ({ id, title }: any) => {
//         console.log("has same", humans.find(el=>el.id === id));
//         if (!humans.find(el=>el.id === id)) {
//             setHumans(prev => [...prev, { id, title }])
//         }
//     }
//     const removeHuman = (id: number) => {
//         const index = humans.indexOf(humans.find(el => el.id === id))
//         if (index > -1) {
//             setHumans(prev => {
//                 const tmp = [...prev]
//                 tmp.splice(index, 1)
//                 return [...tmp]
//             })
//         }
//     }

//     React.useEffect(() => {
//         replace(humans.map(el => el.id))
//     }, [humans])

//     return (
//         <div className="HumanInput__wrapper">
//             <label htmlFor="0" className='text-15'>{props?.label || ""}</label>
//             <div className="HumanInput">
//                 {humans.map((el, index) => <Bubble key={el.id} label={`${el.id},    ${el.title}`} value={el.id} handleDelete={() => { removeHuman(el.id) }} />)}
//                 <AddHumanInput label="Добавить" onClick={() => setOpenADD(prev=>!prev)} />
//                     {/* (data)=>{addHuman(data); setOpenADD(false)} */}
//                 {openAdd && passanger && <PassangersSearch choosePassanger={(data)=>{addHuman(data); setOpenADD(false)}}/>}
//                 {openAdd && !passanger && <EmployeeSearch choosePassanger={(data)=>{addHuman(data); setOpenADD(false)}}/>}
//             </div>
//         </div>
//     )
// }

// export default HumanInput;
export default AddHumanInput;